// src/lib/api/orval-mutator.ts
import type { AxiosRequestConfig } from "axios";

import { axiosInstance } from "./axios";

export const customInstance = async <T>(url: string, options?: RequestInit): Promise<T> => {
  const axiosConfig: AxiosRequestConfig = {
    url,
    method: options?.method as AxiosRequestConfig["method"],
    headers: options?.headers as AxiosRequestConfig["headers"],
    data: options?.body,
  };

  const response = await axiosInstance(axiosConfig);

  return {
    data: response.data,
    status: response.status,
    headers: response.headers,
  } as T;
};
